import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "dashboard",
  class: "mb-5"
}
const _hoisted_2 = { class: "panel-title" }
const _hoisted_3 = { class: "row mt-3" }
const _hoisted_4 = { class: "stat-tile h-100" }
const _hoisted_5 = { class: "stat-label" }

import { ref, onMounted } from "vue";
import { DashboardStat } from "shared/DashboardStats";
import { apiGet } from "@/services/api/client";


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardComponent',
  setup(__props) {

const dashboardStats = ref<DashboardStat[]>([]);

onMounted(async () => {
  try {
    const response = await apiGet("/admin/stats") as DashboardStat[];

    if (response) {
      dashboardStats.value = response;
    }
  } catch (error) {
    console.error("Error fetching dashboard stats:", error);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t('panel.dashboard.generalInfo')), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dashboardStats.value, (stat, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-6 col-md-3 mb-3",
          key: index
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(stat.key && _ctx.$te(`dashboardStats.${stat.key}`) ? _ctx.$t(`dashboardStats.${stat.key}`) : stat.label), 1),
            _createElementVNode("div", {
              class: _normalizeClass(["stat-value", { 'stat-empty': stat.value === null }])
            }, _toDisplayString(stat.value === null ? _ctx.$t("dashboardStats.noData") : stat.unit === "hours" ? `${stat.value} ${_ctx.$t("dashboardStats.hoursUnit")}` : stat.value), 3)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})